import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Home, Receipt, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Paths } from "../constants/Paths";
import useSEO from "../hooks/useSEO";

export default function TourFPaySuccess() {
  const { setSEO } = useSEO();

  React.useEffect(() => {
    setSEO(`Payment Successful | Yatra Tickets`);
  }, [setSEO]);
  const [searchParams] = useSearchParams();
  const oid = searchParams.get("oid");
  const tourBookId = searchParams.get("tourBookId");

  const bookingDetailPath = tourBookId 
    ? Paths.TOUR_BOOKING_DETAIL.replace(":tourBookId", tourBookId)
    : Paths.MY_BOOKINGS;

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-4 bg-slate-50 dark:bg-slate-950">
      <Card className="max-w-md w-full shadow-xl border-none overflow-hidden">
        <div className="h-2 bg-green-500 w-full" />
        <CardHeader className="text-center pt-8">
          <div className="mx-auto w-20 h-20 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-4 animate-in zoom-in duration-500">
            <CheckCircle2 className="w-12 h-12 text-green-600 dark:text-green-400" />
          </div>
          <CardTitle className="text-2xl font-bold text-slate-900 dark:text-slate-50">
            Payment Successful!
          </CardTitle>
          <p className="text-slate-500 mt-2">
            Thank you for your payment. Your booking has been confirmed.
          </p>
        </CardHeader>

        <CardContent className="space-y-6 pt-4 px-8">
          {oid && (
            <div className="bg-slate-100 dark:bg-slate-900 rounded-lg p-4 flex justify-between items-center border border-slate-200 dark:border-slate-800">
              <span className="text-sm font-medium text-slate-500 uppercase tracking-wider">Transaction ID</span>
              <span className="font-mono font-bold text-slate-900 dark:text-slate-100">{oid}</span>
            </div>
          )}

          <div className="space-y-3">
            <p className="text-sm text-center text-slate-600 dark:text-slate-400">
              A confirmation email has been sent to your registered email address.
            </p>
          </div>
        </CardContent>

        <CardFooter className="flex flex-col gap-3 pb-10 pt-6 px-8">
          <Button asChild className="w-full h-11 bg-primary hover:bg-primary/90 text-white font-semibold shadow-lg shadow-primary/20 transition-all active:scale-[0.98]">
            <Link to={bookingDetailPath} className="flex items-center justify-center gap-2">
              <Receipt className="w-4 h-4" />
              {tourBookId ? "View Booking Details" : "View My Bookings"}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>

          <Button variant="outline" asChild className="w-full h-11 border-slate-200 dark:border-slate-800 hover:bg-slate-100 dark:hover:bg-slate-900 font-medium transition-all active:scale-[0.98]">
            <Link to={Paths.HOME} className="flex items-center justify-center gap-2">
              <Home className="w-4 h-4" />
              Return Home
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
